// extracted by mini-css-extract-plugin
export var checkbox = "_3v-0";
export var circle = "_3v-3";
export var horizontalContainer = "_3v-7";
export var sm = "_3v-5";
export var switch0 = "_3v-2";
export var switchDisabled = "_3v-8";
export var switchEnabled = "_3v-1";
export var textSwitchContainer = "_3v-9";
export var textSwitchOption = "_3v-a";
export var textSwitchOptionSelected = "_3v-b";
export var verticalContainer = "_3v-6";
export var xs = "_3v-4";